export const ON_DUTY = 'on-duty';
export const OFF_DUTY = 'off-duty';
